import queryString from "query-string";
import React, { useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Container } from "reactstrap";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import Loading from "../../Components/Loading/Loading";

import { useDispatch, useSelector } from "react-redux";
import PlaceDetails from "../../Components/Places/PlaceDetails";
import { getWaterfallRequest } from "../../store/waterfall/actions";
import InfoWaterfall from "./components/InfoWaterfall";

const WaterfallDetails = () => {
  document.title = "Atrativos naturais | Ecoguias - Admin Dashboard";

  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const { data, loading } = useSelector((state) => state.Waterfall);

  const { search } = useLocation();
  const queryStringParams = queryString.parse(search);

  useEffect(() => {
    dispatch(getWaterfallRequest(id));
  }, [id, dispatch]);

  function renderPlaceDetails() {
    if (!data?.result) {
      return null;
    }

    return (
      <PlaceDetails
        loading={loading}
        data={data?.result?.waterfall}
        images={data?.result?.images}
        pathPaginationName="/waterfalls"
        page={queryStringParams.page}
        menu={<InfoWaterfall data={data?.result?.waterfall} />}
      />
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Atrativos naturais" pageTitle="Locais" />
        </Container>

        {loading ? (
          <Loading />
        ) : (
          <>
            <div className="p-4">
              <button
                className="btn btn-primary"
                onClick={() => history.push("/waterfalls?page=1")}
              >
                Voltar
              </button>
            </div>
            {renderPlaceDetails()}
          </>
        )}
      </div>
    </React.Fragment>
  );
};

export default WaterfallDetails;
